export function validateTableDataRequest (editorRef, variables) {
  const errors = []
  const value = editorRef.current.editor.getValue()
  let request = null
  try {
    request = JSON.parse(value)
  } catch (error) {
    errors.push('Request not parseable')
    return {
      isValid: false,
      errors
    }
  }

  const parsedRequest = {
    pipeline: request,
    variables
  }

  if (!parsedRequest.pipeline?.length) {
    errors.push('At least one pipeline is required')
  }

  return {
    isValid: errors.length === 0,
    errors,
    request,
    parsedRequest
  }
}
